import { mapGetters } from "vuex"

import data_input from "~/components/inputs/dataInput"
import action_button from "~/components/shared/actionButton"

import validity_mixin from "./resetPasswordMixin_validity"

export default {
  mixins: [validity_mixin],
  components: { data_input, action_button },
  data: function () {
    return {
      success: false,
      loading: false,
      email: "",
      errorOutput: "",
    }
  },
  computed: {
    ...mapGetters({
      is_logged_in: "user/IS_LOGGED_IN",
    }),
  },
  methods: {
    probeReset: function () {
      if (this.validate()) this.resetPassword()
      else this.errorOutput = this.$t("auth.resetPassword05")
    },
    resetPassword: function () {
      this.loading = true
      this.email = this.email.trim().toLowerCase()
      this.$axios
        .$post("/auth/request-password-reset/", {
          email: this.email,
        })
        .then(() => {
          this.loading = false
          this.success = true
        })
        .catch(() => {
          this.loading = false
          this.validity.email = false
        })
    },
    close: function () {
      this.$emit("close", false)
    },
  },
  watch: {
    success: function () {
      if (this.success) this.$emit("close", true)
    },
  },
}
